module.exports = {"token_service":{"production":"lts.ccpgames.com","test":"lts-{server}.ccpgames.com","verify":"https://{host}/v2/launcher/verify/","refresh":"https://{host}/v2/launcher/refresh/","eve_eula":"https://{host}/agreements/eve/EULA/"}}


//////////////////
// WEBPACK FOOTER
// ./src/settings/services.json
// module id = 412
// module chunks = 0